var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 79,
    fill: "#F5F5F5",
    stroke: "#3BABA6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9252 91.6053C57.2093 94.4133 44.8445 100.147 52.3755 107.322C56.0544 110.827 60.1516 113.333 65.3029 113.333H94.697C99.8483 113.333 103.946 110.827 107.624 107.322C115.155 100.147 102.791 94.4133 98.0747 91.6053C87.016 85.0203 72.984 85.0203 61.9252 91.6053Z",
    stroke: "#3BABA6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61.6666C95 69.9509 88.2843 76.6666 80 76.6666C71.7157 76.6666 65 69.9509 65 61.6666C65 53.3824 71.7157 46.6666 80 46.6666C88.2843 46.6666 95 53.3824 95 61.6666Z",
    stroke: "#3BABA6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav4);
export default __webpack_public_path__ + "static/media/nav4.0f4e20dbae322c53f408d9e5eff313aa.svg";
export { ForwardRef as ReactComponent };